import React from 'react';
import { Typography } from 'antd';
import { CommentOutlined } from '@ant-design/icons';
//hooks

export default function CommentReadSnackbar({ comments: propsComments }) {
  const [count, setCount] = React.useState(0);

  React.useEffect(() => {

    let newCount = 0;
    propsComments.forEach((comment) => {
      if(comment.type === "comment") {
        checkComment(comment);
      }
    });

    function checkComment(comment) {
      if (comment.isRead === false) {
        newCount++;
      }
      comment.children.forEach((childrenComment) => {
        checkComment(childrenComment);
      });
    }

    setCount(newCount);
  }, [propsComments]);

  newCommentsToggle(count !== 0);

  function newCommentsToggle(hasNumber) {
    // Get the snackbar DIV
    var x = document.getElementById('new-comment-snackbar');

    if (x !== null) {
      // Add the "show" class to DIV
      hasNumber === true ? (x.className = 'show') : (x.className = 'hide');
    }
  }

  return (
    <>
      <div id="new-comment-snackbar">
        <CommentOutlined className="new-comment-snackbar icon" />
        <Typography.Text className="new-comment-snackbar text">
          {`You have ${count} unread comments`}
        </Typography.Text>
      </div>
    </>
  );
}
